import gql from "graphql-tag";

export const GET_TARGETS = gql`
query getTargets {
    targets {id, code, description
    }
}
`;
